import React, { useEffect, useState } from "react";
import HalfDoughnutChartLoss from "./HalfDoughnutChartHumanLoss";
import {
  humanlossdashboardincidenttableblocldata,
  humanlossdashboardincidenttabledata,
} from "../../../../../Services/EndPoints";
import { getData } from "../../../../../Services/Services";
import "../HumanLossDashboard.css";

const HumanLossDougnut = ({
  fromDateNew, toDateNew, applyClicked, onApplyHandled,
  firstLoad, title, selectedIncident,
}) => {
  const [activeTab, setActiveTab] = useState("Charts");
  const [expandedRows, setExpandedRows] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [blockData, setBlockData] = useState([]);

  const getIncidentId = () => {
    const id = selectedIncident?.id;
    return id === 0 ? 0 : id || "ALL";
  };

  const fetchTableData = async () => {
    try {
      const data = await getData(
        humanlossdashboardincidenttabledata
          .replace("FROMDATE", fromDateNew).replace("TODATE", toDateNew)
          .replace("ID", getIncidentId())
      );
      setCardData(data || []);
    } catch (e) { console.error(e); }
  };

  const fetchBlockData = async (distName) => {
    try {
      const data = await getData(
        humanlossdashboardincidenttableblocldata
          .replace("FROMDATE", fromDateNew).replace("TODATE", toDateNew)
          .replace("DISTNAME", distName).replace("ID", getIncidentId())
      );
      setBlockData(data || []);
    } catch (e) { console.error(e); }
  };

  useEffect(() => { if (firstLoad) fetchTableData(); }, [firstLoad]);
  useEffect(() => { if (applyClicked) { fetchTableData(); onApplyHandled(); } }, [applyClicked]);
  useEffect(() => { if (selectedIncident) { fetchTableData(); setExpandedRows([]); } }, [selectedIncident]);

  const handleRowClick = async (distName, idx) => {
    if (expandedRows.includes(idx)) { setExpandedRows([]); return; }
    setExpandedRows([idx]);
    await fetchBlockData(distName);
  };

  const totals = (cardData || []).reduce((t, r) => ({
    incident: t.incident + (r.incident_count || 0),
    deaths: t.deaths + (r.deaths_count || 0),
    injured: t.injured + (r.injured_count || 0),
  }), { incident: 0, deaths: 0, injured: 0 });

  const doughnutConfigs = [
    { title: "Incidents", dataKey: "incident_count" },
    { title: "Deaths", dataKey: "deaths_count" },
    { title: "Injured", dataKey: "injured_count" },
  ];

  return (
    <div className="hld-panel">
      <div className="hld-panel-header">
        <div>
          <div className="hld-panel-title">{title || "All Incidents Data"}</div>
           {activeTab === "Table" && (
            <div className="hld-panel-sub">District-wise breakdown</div>
          )}
        </div>
        {/* Toggle */}
        <div className="hld-toggle">
          {["Charts", "Table"].map(tab => (
            <div key={tab}
              className={`hld-toggle-item${activeTab === tab ? " hld-toggle-item--active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >{tab}</div>
          ))}
        </div>
      </div>

      <div className="hld-panel-body">
        {activeTab === "Charts" ? (
          <div className="hld-grid-3">
            {doughnutConfigs.map(cfg => (
              <div key={cfg.dataKey} className="hld-chart-cell">
                <div className="hld-chart-cell-title">{cfg.title}</div>
                <HalfDoughnutChartLoss
                  title={cfg.title} dataKey={cfg.dataKey}
                  fromDateNew={fromDateNew} toDateNew={toDateNew}
                  applyClicked={applyClicked} onApplyHandled={onApplyHandled}
                  firstLoad={firstLoad} selectedIncident={selectedIncident}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="hld-table-wrap">
            <table className="hld-table">
              <thead>
                <tr>
                  <th style={{ width: 36 }}></th>
                  <th style={{ width: 40 }}>S.No</th>
                  <th>District Name</th>
                  <th style={{ textAlign: "center" }}>Incidents</th>
                  <th style={{ textAlign: "center" }}>Deaths</th>
                  <th style={{ textAlign: "center" }}>Injured</th>
                </tr>
              </thead>
              <tbody>
                {(cardData || []).map((row, i) => (
                  <React.Fragment key={i}>
                    <tr onClick={() => handleRowClick(row.dist_name, i)}>
                      <td><span className="hld-expand-btn">{expandedRows.includes(i) ? "−" : "+"}</span></td>
                      <td>{i + 1}</td>
                      <td>{row.dist_name}</td>
                      <td style={{ textAlign: "center" }}>{row.incident_count}</td>
                      <td style={{ textAlign: "center" }}>{row.deaths_count}</td>
                      <td style={{ textAlign: "center" }}>{row.injured_count}</td>
                    </tr>
                    {expandedRows.includes(i) && (
                      <tr>
                        <td colSpan="6" style={{ padding: 0 }}>
                          <div className="hld-inner-table-wrap">
                            <table className="hld-inner-table">
                              <thead><tr><th>Block Name</th><th style={{ textAlign: "center" }}>Incidents</th><th style={{ textAlign: "center" }}>Deaths</th><th style={{ textAlign: "center" }}>Injured</th></tr></thead>
                              <tbody>
                                {(blockData || []).map((b, bi) => (
                                  <tr key={bi}>
                                    <td>{b.block_name}</td>
                                    <td style={{ textAlign: "center" }}>{b.incident_count}</td>
                                    <td style={{ textAlign: "center" }}>{b.deaths_count}</td>
                                    <td style={{ textAlign: "center" }}>{b.injured_count}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3">Total</td>
                  <td style={{ textAlign: "center" }}>{totals.incident}</td>
                  <td style={{ textAlign: "center" }}>{totals.deaths}</td>
                  <td style={{ textAlign: "center" }}>{totals.injured}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default HumanLossDougnut;